import React, { useState } from "react";

import { withRouter } from "react-router-dom";

import {
  Table,
  Card,
  Input,
  DatePicker,
  Button,
  Select,
  Row,
  Col,
  Icon,
} from "antd";

import MaskedInput from "react-text-mask";
import { dateFormat } from "../../Helper/dateFormat";
import moment from "moment";
import AllDataUser from "../../Hook/hookData";
import bilingual from "../../Helper/bilingual";
import i18next from "i18next";

const { RangePicker } = DatePicker;
const { Option } = Select;

const FilterSectionClaim = ({
  searchDataClaim,
  handleSearchClaim,
  onSearchClaim,
  onCreateInvoice,
  dataClaimStatus,
  dataClaim,
  reloadClaimStatus,
}) => {
  const { lang } = AllDataUser();

  bilingual(lang);
  return (
    <>
      <Card
        style={{ marginBottom: 16, marginTop: 16 }}
        bodyStyle={{
          padding: 0,
          paddingRight: 16,
          paddingTop: 8,
          paddingBottom: 8,
        }}
      >
        <Row>
          <Col xs={24} sm={12} md={12} lg={7}>
            <div
              style={{
                borderRight: "1.5px solid #e8e8e8",
                paddingRight: 16,
                paddingLeft: 16,
                borderBottom: {
                  xs: "1px solid #e8e8e8",
                  sm: "1px solid #e8e8e8",
                  md: "none",
                },
                minHeight: "80px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  color: "#262626",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                {i18next.t("AdmissionDate")}
              </div>
              <RangePicker
                value={
                  searchDataClaim.admissionStartDate &&
                  searchDataClaim.admissionEndDate
                    ? [
                        moment(searchDataClaim.admissionStartDate, dateFormat),
                        moment(searchDataClaim.admissionEndDate, dateFormat),
                      ]
                    : [] // kosong kalau belum ada
                }
                format={dateFormat}
                onChange={(date, dateString) => {
                  handleSearchClaim(
                    "admissionStartDate",
                    dateString[0] || null
                  );
                  handleSearchClaim("admissionEndDate", dateString[1] || null);
                }}
                dateRender={(current) => {
                  const style = {};
                  if (current.date() === 1) {
                    style.border = "1px solid #1890ff";
                    style.borderRadius = "50%";
                  }
                  return (
                    <div className="ant-calendar-date" style={style}>
                      {current.date()}
                    </div>
                  );
                }}
              />
            </div>
          </Col>

          {/* <Col
            xs={24}
            sm={12}
            md={12}
            lg={4}
            style={{ borderRight: "1px solid #e8e8e8" }}
          >
            <div
              style={{
                paddingLeft: 16,
                minHeight: "80px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                width: "100px",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  color: "#262626",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Status
              </div>
              <Select
                showSearch
                allowClear
                optionFilterProp="children"
                style={{
                  width: "120px",
                }}
                disabled={dataClaimStatus.isFetching}
                loading={dataClaimStatus.isFetching}
                value={searchDataClaim.claimStatus}
                onChange={(value) => handleSearchClaim("claimStatus", value)}
                notFoundContent={
                  dataClaimStatus.error ? (
                    <div
                      style={{
                        textAlign: "center",
                        padding: 8,
                        color: "red",
                      }}
                    >
                      <div style={{ marginBottom: 4 }}>Error</div>
                      <Button
                        type="dashed"
                        size="small"
                        icon="reload"
                        onClick={reloadClaimStatus}
                      >
                        {i18next.t("Reload")}
                      </Button>
                    </div>
                  ) : null
                }
              >
                {!dataClaimStatus.error &&
                  dataClaimStatus.data &&
                  dataClaimStatus.data.data.map((val) => (
                    <Option
                      key={val.ClaimStatusID}
                      value={val.ClaimStatusID}
                      title={val.ClaimStatus}
                    >
                      {val.ClaimStatus}
                    </Option>
                  ))}
              </Select>
            </div>
          </Col> */}

          <Col xs={24} sm={12} md={12} lg={4}>
            <div
              style={{
                borderRight: "1px solid #e8e8e8",
                paddingLeft: 16,
                borderBottom: {
                  xs: "1px solid #e8e8e8",
                  sm: "1px solid #e8e8e8",
                  md: "none",
                },
                minHeight: "80px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  color: "#262626",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                {i18next.t("ClaimNumber")}
              </div>
              <Input
                value={searchDataClaim.rocNo}
                placeholder="Claim Number"
                onChange={(e) => handleSearchClaim("rocNo", e.target.value)}
                style={{
                  border: "none",
                  padding: 0,
                  fontSize: "14px",
                  color: "#8c8c8c",
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  width: "70%",
                  borderBottom: "1px solid #e8e8e8",
                }}
                className="borderless-input"
              />
            </div>
          </Col>

          <Col xs={24} sm={12} md={12} lg={5}>
            <div
              style={{
                // borderRight: "1px solid #e8e8e8",
                paddingLeft: 16,
                minHeight: "80px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  color: "#262626",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                {i18next.t("CardNumber")}
              </div>
              <style>
                {`
                #my-input-id::placeholder {
                  color: #bfbfbf;
                  opacity: 1;
                  font-size: 14px;
                }
              `}
              </style>
              <MaskedInput
                width={"100%"}
                mask={[
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  "-",
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  "-",
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  "-",
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                className="form-control"
                placeholder="XXXX-XXXX-XXXX-XXXX"
                guide={false}
                id="my-input-id"
                value={searchDataClaim.cardNumb}
                onBlur={() => {}}
                onChange={(e) => handleSearchClaim("cardNumb", e.target.value)}
                style={{
                  border: "none",
                  padding: 0,
                  fontSize: "14px",
                  color: "#8c8c8c",
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  width: "100%",
                  outline: "none",
                  marginTop: 5,
                }}
                autoComplete="off"
              />
              <span
                style={{
                  color: "#8c8c8c",
                  boxShadow: "none",
                  width: "70%",
                  borderBottom: "1.5px solid #e8e8e8",
                  borderRadius: 0,
                  marginTop: 5,
                }}
              />
            </div>
          </Col>

          <Col xs={24} sm={24} md={24} lg={8}>
            <div
              style={{
                paddingLeft: 16,
                minHeight: "80px",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                // border: "solid 1px red",
              }}
            >
              <Button
                disabled={dataClaimStatus.isFetching}
                type="primary"
                icon="search"
                onClick={onSearchClaim}
                style={{
                  borderRadius: "50%",
                  width: 48,
                  height: 48,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
            </div>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default withRouter(FilterSectionClaim);
